import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  apiCallWithApiKey,
  get,
  getAnonymous,
  getApiV2,
  IDOR_HEADER_V2,
  putApiV2,
} from '../services/api';
import {
  applicationMessagesLoaded,
  contentfulPageLoaded,
  generalDataLoaded,
  getContentfulPage as GET_CONTENTFUL_PAGE,
  getLanguages as GET_LANGUAGES,
  getSharePostDataFailed,
  getSharePostDataSuccess,
  languagesLoadedFailed,
  languagesLoadedSuccess,
  linkMessageSent,
  publicSideImageLoaded,
  saveLanguagePreference as SAVE_LANGUAGE_PREFERENCE,
} from '../actions';
import { SMS_APP_LINKS } from '../constants';
import {
  usePetCloudRNNotificationV1T159707ForSagas,
} from '../services/featureFlagsForSagas';

export function* sendLinkMessage(dispatch, { payload }) {
  const options = {
    body: {
      body: SMS_APP_LINKS,
      toPhone: payload.toPhone,
    },
    method: 'POST',
  };

  const response = yield call(
    apiCallWithApiKey,
    'api/Quote/SendSMS',
    options,
    dispatch,
  );

  yield put(linkMessageSent(response.success && response.IsValid));
}

export function* clearAllCustomerCache(dispatch) {
  const url = 'api/User/ClearAllCustomerCache';
  yield call(get, dispatch, url);
}

export function* clearUserCache(dispatch) {
  const url = 'api/User/ClearCache';
  yield call(get, dispatch, url);
}

export function* getSharePostData(dispatch, { payload }) {
  const { postId } = payload;

  const response = yield call(
    apiCallWithApiKey,
    `api/Social/Share/Post/${postId}`,
    { headers: IDOR_HEADER_V2 },
    dispatch,
  );

  if (response.IsValid && response.Data) {
    yield put(getSharePostDataSuccess(response.Data));
  } else {
    yield put(getSharePostDataFailed());
  }
}

export function* getPublicSideImage(dispatch) {
  const response = yield call(
    apiCallWithApiKey,
    'api/Contentful/GetSignInPage/true',
    dispatch,
  );

  if (response.IsValid && response.Data) {
    yield put(publicSideImageLoaded(response.Data.ImageUrl));
  }
}

export function* getGeneralData() {
  const response = yield call(get, null, 'api/GeneralData');
  if (response.IsValid && response.Data) {
    yield put(generalDataLoaded(response.Data.PoliciesInfo));
  }
}

export function* getApplicationMessages(dispatch) {
  const usePetCloudRNNotificationv1T159707 =
    yield usePetCloudRNNotificationV1T159707ForSagas();

  const petcloudOs = 1;
  const urlService = usePetCloudRNNotificationv1T159707 ? 'social' : 'api';
  const url = `${urlService}/Notification/GetUrgentMessage/${petcloudOs}`;

  const response = yield call(get, dispatch, url);

  if (response?.IsValid) {
    yield put(applicationMessagesLoaded(response.Data));
  }
}

export function* getContentfulPage({ payload }) {
  const isPublished = process.env.REACT_APP_NAME === 'Prod';
  const response = yield call(
    getAnonymous,
    null,
    `social/contentful/general/${payload}/${isPublished}`,
  );

  yield put(contentfulPageLoaded(response));
}

export function* getLanguages() {
  const response = yield call(getApiV2, null, 'customer/languages');

  if (response.success) {
    yield put(languagesLoadedSuccess(response.data));
  } else {
    yield put(languagesLoadedFailed());
  }
}

export function* saveLanguagePreference({ payload }) {
  const { preferredLanguage } = payload;
  const body = { preferredLanguage };
  yield call(putApiV2, null, 'customer/languages', body);
}

export function* commonSaga() {
  yield all([
    takeLatest(GET_CONTENTFUL_PAGE, getContentfulPage),
    takeLatest(GET_LANGUAGES, getLanguages),
    takeLatest(SAVE_LANGUAGE_PREFERENCE, saveLanguagePreference),
  ]);
}
